import type { ResolvedPreferences } from '../contract/types';
import { useLocalizationContext } from './useLocalizationContext';

/**
 * The resolved preferences themselves.
 *
 * For the smaller set of callers that need the preference rather than a value expressed in it: a
 * chart labelling an axis with the unit, a date picker asking which day the week starts on, a
 * component that has to name the time zone it is showing. Anything rendering a measurement wants
 * `useFormat()` instead.
 *
 * Identity is stable for as long as the preferences hold, so this is safe in a dependency array.
 *
 * @returns The resolved preferences. See {@link ResolvedPreferences}.
 * @throws If no `<LocalizationProvider>` is mounted above the caller.
 */
export const useLocalizationPreferences = (): ResolvedPreferences =>
  useLocalizationContext().preferences;
